import { GzContentControlNetworkMonitorWebComponent } from './component/GzContentControlNetworkMonitorWebComponent';

export { GzContentControlNetworkMonitorWebComponent };
